<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always"></div>
<h1 class="P_Heading_1__And__Centre_Alignment__And__Spacing_After__And__Spacing_Before__And__Page_Break"><span style=" font-family: Georgia; font-style: normal; font-size: 2.00em;">PREFACE</span><span style=" font-family: Georgia; font-style: normal; font-size: 1.20em;"> </span></h1>
<p class="P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"><span style=" font-family: Georgia; font-style: italic; font-size: 1.20em;">The Honeywood File</span><span style=" font-family: Georgia; font-size: 1.20em;"> described the building of a house, and the present volume carries the history to conclusion ten months later when the last defect has been remedied, the last dispute settled, and the last account paid.</span></p>
<p class="P_Standard__And__Justification__And__Left_Indent__And__Right_Indent__OPENPAR_2_CLOSEPAR_"><span style=" font-family: Georgia; font-size: 1.20em;">The aspirant to architectural practice—unlike the general reader—is more interested in building houses than in occupying them; but the proof of a pudding is in the eating, and by showing the consequences that flowed from events recorded in the earlier book, </span><span style=" font-family: Georgia; font-style: italic; font-size: 1.20em;">The Honeywood Settlement</span><span style=" font-family: Georgia; font-size: 1.20em;"> completes the lesson of </span><span style=" font-family: Georgia; font-style: italic; font-size: 1.20em;">The Honeywood File</span><span style=" font-family: Georgia; font-size: 1.20em;">.</span></p>
<p class="P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent"><span class="C_Current__And__Georgia">H.B.C.</span></p>
<p class="P_Standard__And__Dante_MT_Std_Italic__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?307d6d13